module.exports = __webpack_public_path__ + "img/grey-check.5a19bba9.svg";